import React from 'react';
import './TheTeacherDashboard.css';
import {
  HiOutlineArrowUturnLeft,
  HiOutlineCheckCircle,
  HiOutlineClipboardDocumentList,
  HiOutlineClock,
  HiOutlineDocumentCheck,
  HiOutlineDocumentText,
  HiOutlineMagnifyingGlass,
  HiOutlineQuestionMarkCircle,
  HiOutlineShieldCheck,
  HiOutlineSparkles
} from 'react-icons/hi2';
import { history } from "../../../../../../helper/history"
import { routes } from '../../../../../../helper/routes';

export default function TeacherAssessmentLibrary({
  totalCountMyAssessments,
  totalCountPublicAssessments,
  questionCount,
  categoryCount,
  loadingQuestions,
  loadingCategories,
  assessmentCounts,
  employeeType
}) {

  const onStatusClick = (item) => {

    const state = {
      filter: "Status",
      name: item.status_name,
      value: item.status_id,
    }

    history.push({
      pathname: routes.view_assessment_review,
      state: { ...state },
    });

  };

  const getStatusIcon = (statusName) => {
    const normalized = (statusName || '').toLowerCase();

    if (normalized === 'initial') return HiOutlineClock;
    if (normalized === 'ready') return HiOutlineCheckCircle;
    if (normalized === 'review' || normalized === 'inreview') return HiOutlineMagnifyingGlass;
    if (normalized === 'referback') return HiOutlineArrowUturnLeft;
    if (normalized === 'proofreading') return HiOutlineDocumentCheck;
    if (normalized === 'reviewcompleted') return HiOutlineShieldCheck;
    if (normalized === 'published') return HiOutlineSparkles;
    if (normalized === 'readytopublish') return HiOutlineCheckCircle;

    return HiOutlineCheckCircle;
  };

  return (
    <div className="teacher-assessment-library papers-card">
      <div className="papers-header">
        <h6 className="assessment-title">Papers and Questions Overview</h6>
        <span className="papers-chip">Live Updates</span>
      </div>

      <div className="papers-stats">
        <div className="papers-stat papers-stat--questions">
          <HiOutlineQuestionMarkCircle className="papers-stat-icon" />
          <div className="papers-stat-label">All Questions</div>
          <div className="papers-stat-value">{loadingQuestions ? "..." : (questionCount || 0)}</div>
        </div>
        <div className="papers-stat papers-stat--questions-alt">
          <HiOutlineClipboardDocumentList className="papers-stat-icon" />
          <div className="papers-stat-label">My Questions</div>
          <div className="papers-stat-value">{loadingCategories ? "..." : (categoryCount || 0)}</div>
        </div>
        <div className="papers-stat papers-stat--papers">
          <HiOutlineDocumentText className="papers-stat-icon" />
          <div className="papers-stat-label">My Papers</div>
          <div className="papers-stat-value">{loadingQuestions ? "..." : (totalCountMyAssessments || 0)}</div>
        </div>
        <div className="papers-stat papers-stat--papers-alt">
          <HiOutlineDocumentCheck className="papers-stat-icon" />
          <div className="papers-stat-label">All Papers</div>
          <div className="papers-stat-value">{loadingQuestions ? "..." : (totalCountPublicAssessments || 0)}</div>
        </div>
      </div>

      <div className="papers-status-grid">
        {assessmentCounts?.map((item, index) => {
          const disabledStatuses = ["Initial", "Ready", "Published"];
          const isDisabled = disabledStatuses.includes(item?.status_name);

          const StatusIcon = getStatusIcon(item?.status_name);

          return (
            <button
              key={index}
              className={`papers-status-pill ${isDisabled ? 'papers-status-pill--muted' : 'papers-status-pill--active'}`}
              onClick={() => {
                if (!isDisabled) {
                  onStatusClick(item);
                }
              }}
              type="button"
            >
              <span className="papers-status-left">
                <StatusIcon className="papers-status-icon" />
                <span className="papers-status-name">{item?.status_name || "N/A"}</span>
              </span>
              <span className="papers-status-count">{item?.count || "0"}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
